import { type AnyAction, combineReducers } from 'redux';

import {
    CLOSE_MODAL,
    CLOSE_SNACKBAR,
    HIDE_BLOCK_NAVIGATION_MODAL,
    SHOW_BLOCK_NAVIGATION_MODAL,
    SHOW_MODAL,
    SHOW_SNACKBAR
} from '../actions/actionTypes/ui';
import { LOGOUT } from '../actions/actionTypes/user';
import { type UIState } from '../types';

export const initialState: UIState = {
    modal: { key: null },
    snackbar: { isOpen: false, messageType: undefined, messageKey: undefined },
    blockNavigation: {
        isOpen: false,
        canLeave: null,
        title: '',
        body: '',
        cancelButtonText: '',
        confirmButtonText: '',
        isHighAlertButton: false
    }
};

const blockNavigationReducer = (state = initialState.blockNavigation, action: AnyAction) => {
    const { type } = action;
    switch (type) {
        case SHOW_BLOCK_NAVIGATION_MODAL: {
            const {
                canLeave,
                title,
                body,
                cancelButtonText,
                confirmButtonText,
                isHighAlertButton
            } = action.payload;
            return {
                ...state,
                isOpen: true,
                canLeave,
                title,
                body,
                cancelButtonText,
                confirmButtonText,
                isHighAlertButton
            };
        }
        case HIDE_BLOCK_NAVIGATION_MODAL:
            return initialState.blockNavigation;

        default:
            return state;
    }
};

const modalReducer = (state = initialState.modal, action: AnyAction) => {
    const { type, payload } = action;
    switch (type) {
        case SHOW_MODAL: {
            return { key: payload.modalKey };
        }
        case CLOSE_MODAL: {
            return { key: null };
        }

        default:
            return state;
    }
};

const snackbarReducer = (state = initialState.snackbar, action: AnyAction) => {
    const { type, payload } = action;
    switch (type) {
        case SHOW_SNACKBAR: {
            return { isOpen: true, ...payload };
        }
        case CLOSE_SNACKBAR: {
            return { isOpen: false };
        }
        default:
            return state;
    }
};

const uiReducer = combineReducers({
    modal: modalReducer,
    snackbar: snackbarReducer,
    blockNavigation: blockNavigationReducer
});

export const ui = (state: UIState | undefined, action: AnyAction): UIState => {
    if (action.type === LOGOUT) {
        return initialState;
    }

    return uiReducer(state, action);
};
